import React from 'react';
import { useWatch } from 'react-hook-form';
import { Grid, Typography } from '@mui/material';
import { NumberField, SelectField } from 'react-admin';

import { transactionMonitoringModesChoices } from '../../../constants/transactionMonitoringMode';
import thresholdModes, { thresholdModeChoices } from '../../../constants/thresholdModes';
import { timePeriodChoices } from '../../../constants/timePeriods';
import { priorityChoices } from '../../../constants/thresholdPriorities';
import { ThresholdField } from '../ruleParamsShortSummaries/AmountThreshold';
import TransactionTypeConfigurationField from '../../../customFields/TransactionTypeConfigurationField';

const TransactionThreshold = () => {
  const thresholdMode = useWatch({ name: 'ruleParameters.thresholdMode' });

  const showDefault = thresholdMode === thresholdModes.DEFAULT_ONLY
    || thresholdMode === thresholdModes.BOTH;
  const showForm = thresholdMode === thresholdModes.KYC_ONLY
    || thresholdMode === thresholdModes.BOTH;
  const showPriority = thresholdMode === thresholdModes.BOTH;

  return (
    <Grid size={12}>
      <Grid container spacing={3}>
        <Grid size={12}>
          <Typography fontWeight="bold">
            Transaction types configuration
          </Typography>
          <TransactionTypeConfigurationField source="ruleParameters.transactionTypeConfiguration" />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <Typography fontWeight="bold">
            Transaction monitoring mode
          </Typography>
          <SelectField
            source="ruleParameters.transactionMonitoringMode"
            choices={transactionMonitoringModesChoices}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <Typography fontWeight="bold">
            Threshold mode
          </Typography>
          <SelectField
            source="ruleParameters.thresholdMode"
            choices={thresholdModeChoices}
          />
        </Grid>
        {showDefault && (
          <Grid
            size={{
              xs: 12,
              md: 6,
            }}
          >
            <Typography fontWeight="bold">
              Default threshold
            </Typography>
            <ThresholdField source="ruleParameters.default" />
          </Grid>
        )}
        {showForm && (
          <>
            <Grid
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <Typography fontWeight="bold">
                KYC form threshold
              </Typography>
              <ThresholdField source="ruleParameters.form" unit="%" />
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <Typography fontWeight="bold">
                KYC form max age
              </Typography>
              <NumberField source="ruleParameters.kycFormDataMaxAge" options={{ style: 'unit', unit: 'day', unitDisplay: 'long' }} />
            </Grid>
          </>
        )}
        {showPriority && (
          <Grid
            size={{
              xs: 12,
              md: 6,
            }}
          >
            <Typography fontWeight="bold">
              Threshold priority
            </Typography>
            <SelectField source="ruleParameters.parameterPriority" choices={priorityChoices} />
          </Grid>
        )}
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <Typography fontWeight="bold">
            Period
          </Typography>
          <Typography>
            <NumberField source="ruleParameters.period.amount" />
            {' '}
            <SelectField source="ruleParameters.period.unit" choices={timePeriodChoices} />
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TransactionThreshold;
